const incidentCategories = (() => {
  let categoryTable, subCategoryTable;
  let subCategoryData, categoryData;
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }

  function showAlreadyExistsWarning(msg,form) {
    const warningPopup = POPUP.build({ hideX: true });
    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.classList.add('visible');
        form.buttons['cancel'].toggleDisabled(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [...formInstance.form.querySelectorAll(`input:invalid,select:invalid`),];
    const allElements = [...formInstance.form.querySelectorAll('input:valid, select:valid')];
    const isFormValid = Array.from(allElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0 || !isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  // Incident Categories/Subcategories
  //-------------------------------------------------------------------------------

  function getIncidentView() {
    const frag = document.createDocumentFragment();

    const viewCateHeading = document.createElement('h1');
    viewCateHeading.classList.add('viewHeading');
    viewCateHeading.textContent = 'Subcategories';

    categoryTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Name'],
      endIcon: true,
    });
    subCategoryTable = table.build({
      tableId: 'categoryTable',
      columnHeadings: ['Subcategory', 'Category'],
      endIcon: true,
    });

    const headers = categoryTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const headersSub = subCategoryTable.querySelectorAll('.header div');
    headersSub[0].setAttribute('data-type', 'string');
    headersSub[1].setAttribute('data-type', 'string');

    const addCategoryBtnDiv = document.createElement('div');
    const addCategoryBtn = new Button({
      text: 'ADD NEW CATEGORY',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    const addSubCategoryBtnDiv = document.createElement('div');
    const addSubCategoryBtn = new Button({
      text: 'ADD NEW SUBCATEGORY',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(categoryTable);
    if ($.session.SetupInsert) {
      addCategoryBtn.button.style.float = 'right';
      addCategoryBtn.renderTo(addCategoryBtnDiv);
      frag.append(addCategoryBtnDiv);
    }
    frag.append(viewCateHeading);
    frag.append(subCategoryTable);
    if ($.session.SetupInsert) {
      addSubCategoryBtn.button.style.float = 'right';
      addSubCategoryBtn.renderTo(addSubCategoryBtnDiv);
      frag.append(addSubCategoryBtnDiv);
    }
    const tableCategoryData = categoryData
      .map(p => {
        return {
          values: [p.categoryName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showCategoryPopup(p);
          },
          endIconCallback: () => handleCategoryDelete(p),
        };
      });

    table.populate(categoryTable, tableCategoryData);
    table.sortTableByHeader(categoryTable);

    const tableSubCategoryData = subCategoryData
      .map(p => {
        return {
          values: [p.subCategoryName, p.categoryName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showSubCategoryPopup(p);
          },
          endIconCallback: () => handleSubCategoryDelete(p),
        };
      });

    table.populate(subCategoryTable, tableSubCategoryData);
    table.sortTableByHeader(subCategoryTable);

    addCategoryBtn.onClick(e => {
      showCategoryPopup();
    });
    addSubCategoryBtn.onClick(e => {
      showSubCategoryPopup();
    });

    return frag;
  }

  // Incident Categories
  //-------------------------------------------------------------------------------

  function showCategoryPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const categoryForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Name',
          id: 'cName',
          required: true,
        },
      ],
    });

    categoryForm.onKeyup(() => {
      categoryForm.inputs['cName'].setValidtyError('');
      categoryForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(categoryForm);
    });
    categoryForm.onChange(event => {
      categoryForm.inputs['cName'].setValidtyError('');
      categoryForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(categoryForm);
    });

    categoryForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentCategoryData', {
          id: rowData ? rowData.categoryId : 0,
          category: formdata.cName.trim(),
          userId: $.session.UserId
        })
      ).insertUpdateIncidentCategoryDataResult;
      const newID = resp.CategoryID;
      if (newID == '-1') {
        showAlreadyExistsWarning('This category already exists.', categoryForm);
        categoryForm.buttons['cancel'].toggleDisabled(true);
        categoryForm.buttons['submit'].toggleDisabled(true);
      } else {
        categoryForm.clear();
        POPUP.hide(popup);
        await Promise.all([getSubCategoryData(), getCategoryData()]);
        updateCategoryTable();
        updateSubCategoryTable();
      }
    });

    categoryForm.onCancel(event => {
      categoryForm.clear();
      categoryForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    categoryForm.renderTo(popup);

    POPUP.show(popup);

    categoryForm.populate({
      cName: rowData ? rowData.categoryName : '',
    });

    categoryForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      categoryForm.disableFormInputs();
    }
  }

  async function handleCategoryDelete(row) {
    const rowData = categoryData.find(a => a.categoryId == row.categoryId);

    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This category cannot be deleted, because it is associated  to a subcategory.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this category?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentCategoryData', {
            categoryId: row.categoryId,
          });

          await getCategoryData();
          updateCategoryTable();
        }
      });
    }
  }
  function updateCategoryTable() {
    const tableCategoryData = categoryData
      .map(p => {
        return {
          values: [p.categoryName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showCategoryPopup(p);
          },
          endIconCallback: () => handleCategoryDelete(p),
        };
      });

    table.populate(categoryTable, tableCategoryData);
  }

  async function getCategoryData() {
    const dataCategory = await _UTIL.fetchData('getIncidentCategories');
    categoryData = dataCategory.getIncidentCategoriesResult;
  }

  //  Subcategories
  //-------------------------------------------------------------------------------

  function showSubCategoryPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const subCategoryForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Name',
          id: 'cSubcategory',
          required: true,
        },
        {
          type: 'select',
          label: 'Category',
          id: 'cCategory',
          data: getCategoryDropdownData(),
          includeBlankOption: true,
          required: true,
        },
      ],
    });

    subCategoryForm.onKeyup(() => {
      subCategoryForm.inputs['cSubcategory'].setValidtyError('');
      subCategoryForm.inputs['cSubcategory'].clearErrorOrWarning();
      checkForRequiredFields(subCategoryForm);
    });
    subCategoryForm.onChange(event => {
      subCategoryForm.inputs['cSubcategory'].setValidtyError('');
      subCategoryForm.inputs['cSubcategory'].clearErrorOrWarning();
      checkForRequiredFields(subCategoryForm);
    });

    subCategoryForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentSubCategoryData', {
          id: rowData ? rowData.subCategoryId : 0,
          category: formdata.cCategory,
          subCategory: formdata.cSubcategory.trim(),
          userId: $.session.UserId
        })
      ).insertUpdateIncidentSubCategoryDataResult;

      const newID = resp.CategoryID;
      if (newID == '-1') {
        subCategoryForm.buttons['submit'].toggleDisabled(true);
        subCategoryForm.buttons['cancel'].toggleDisabled(true);
        showAlreadyExistsWarning('This subcategory already exists.', subCategoryForm);      
      } else {
        subCategoryForm.clear();
        POPUP.hide(popup);
        await Promise.all([getSubCategoryData(), getCategoryData()]);
        updateCategoryTable();
        updateSubCategoryTable();
      }
    });

    subCategoryForm.onCancel(event => {
      subCategoryForm.clear();
      subCategoryForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    subCategoryForm.renderTo(popup);
     
    POPUP.show(popup);

    subCategoryForm.populate({
      cSubcategory: rowData ? rowData.subCategoryName : '',
      cCategory: rowData ? rowData.categoryId : '',
    });

    subCategoryForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      subCategoryForm.disableFormInputs();
    }
  }

  function getCategoryDropdownData() {
    let data = [];
    for (const cd of categoryData) {
      data.push({
        value: cd.categoryId,
        text: cd.categoryName,
      });
    }
    return data;
  }

  async function handleSubCategoryDelete(row) {
    const rowData = subCategoryData.find(a => a.subCategoryId == row.subCategoryId);
    if (rowData.isAccountExistCount == 'N') {
      showDeleteConfirmationPopup('Are you sure you want to delete this subcategory?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentSubCategoryData', {
            subCategoryId: row.subCategoryId,
          });

          await Promise.all([getSubCategoryData(), getCategoryData()]);
          updateCategoryTable();
          updateSubCategoryTable();
        }
      });
    } else {
      showUnableToDeletePopup('This subcategory cannot be deleted, because it is associated to an existing incident.');
    }
  }

  function updateSubCategoryTable() {
    const tableSubCategoryData = subCategoryData
      .map(p => {
        return {
          values: [p.subCategoryName, p.categoryName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showSubCategoryPopup(p);
          },
          endIconCallback: () => handleSubCategoryDelete(p),
        };
      });

    table.populate(subCategoryTable, tableSubCategoryData);
  }

  async function getSubCategoryData() {
    const dataSubCategory = await _UTIL.fetchData('getIncidentSubcategories');
    subCategoryData = dataSubCategory.getIncidentSubcategoriesResult;
  }

  // Main
  //-------------------------------------------------------------------------------
  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();
    await Promise.all([getSubCategoryData(), getCategoryData()]);

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = 'Categories';

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Categories / Subcategories') {
      viewMarkup = getIncidentView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  return {
    getView,
  };
})();
